/*
 * @Author: 李明明
 * @Date: 2024-01-29 16:50:24
 * @LastEditTime: 2024-08-05 17:42:07
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /ykt-micro-main/src/plugins/element.js
 * 代码版权方：'政府采购信息网'
 */
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import * as icons from "@element-plus/icons-vue";

export default (app) => {
  app.use(ElementPlus, { locale: zhCn });
  configIcon(app, "DocumentDelete");
  configIcon(app, "Search");
  configIcon(app, "Plus");
  configIcon(app, "Delete");
  configIcon(app, "UploadFilled");
  configIcon(app, "WarningFilled");
  configIcon(app, "Warning");
};
const configIcon = (app, name) => {
  app.component(name, icons[name]);
};
